export const OAUTH_POPUP_PENDING_KEY = "oauth_popup_pending";
export const OAUTH_REDIRECT_PENDING_KEY = "oauth_redirect_pending";
export const OAUTH_REDIRECT_PROVIDER_ID_KEY = "oauth_redirect_provider_id";
export const OAUTH_REDIRECT_FROM_KEY = "oauth_redirect_from";
export const OAUTH_REDIRECT_KEY = "oauth_redirect_key";
export const LINK_PENDING_CREDENTIAL_KEY = "link_pending_credential";
export const OAUTH_ACCOUNT_LINK_PENDING_KEY = "oauth_account_link_pending";
